import { byBrand } from "@repo/tailwind-config/brand";

const PRODUCT_NAME = byBrand({
  owlet: "Owlet OnCall",
  kinsa: "Kinsa Clinic",
});

export const SUPPORT_EMAIL = byBrand({
  owlet: "support@owletoncall.zendesk.com",
  kinsa: "support@kinsaclinic.zendesk.com",
});

export default PRODUCT_NAME;
